import axios from "axios";
import actions from "./actions";
import _ from "lodash";

const fetchMagnetReport = (id, options) => (dispatch, getState) => {
  dispatch(actions.fetchMagnetReportStart());
  const { token, sharedMagnetReport } = options;
  function retryOnFail(task, attempt) {
    if (!attempt) {
      attempt = 1;
    }
    return task().catch(err => {
      if (attempt < 3) {
        attempt += 1;
        return retryOnFail(task, attempt);
      } else {
        dispatch(actions.fetchMagnetReportError(err));
      }
    });
  }
  function getResource(url) {
    return retryOnFail(function() {
      return axios.get(url);
    });
  }
  getResource(`/api/summary-reports/${id}?token=${token}`).then(res => {
    const magnetReport = res.data;

    magnetReport.version = {
      region: "US",
      major: 1,
      minor: 0,
      patch: 0,
    };
    magnetReport.actualSurvey = magnetReport.survey;
    let survey = magnetReport.survey;
    if (survey.startsWith("UK_")) {
      magnetReport.version.region = "UK";
      survey = survey.replace(/^UK_/, "");
    }

    var myRegexp = /_v(\d+)\.(\d+)\.(\d+)$/g;
    var match = myRegexp.exec(survey);
    if (match) {
      magnetReport.version.major = parseInt(match[1]);
      magnetReport.version.minor = parseInt(match[2]);
      magnetReport.version.patch = parseInt(match[3]);
      survey = survey.replace(/_v\d+\.\d+\.\d+$/, "");
    }

    if (_.includes(["AHS", "AMITA"], magnetReport.actualSurvey)) {
      survey = "SCOR";
    }

    magnetReport.survey = survey;

    const sharedUnits = sharedMagnetReport && sharedMagnetReport.sharedUnits;
    const sharedUnitsSet = new Set();
    if (sharedUnits) {
      for (let i = 0; i < sharedUnits.length; i++) {
        sharedUnitsSet.add(sharedUnits[i]);
      }
    }
    let promise;
    if (!sharedMagnetReport || sharedUnitsSet.has("*") || sharedUnits.length > 1) {
      promise = getResource(
        `/api/survey/${magnetReport.datasetId}_${magnetReport.resultSetId}/units?token=${token}&version=${
          magnetReport.actualSurvey
        }&optimized=${magnetReport.optimized}`
      ).then(res => res.data);
    } else {
      const units = [];
      if (sharedUnits.length > 0) {
        units.push({ value: sharedUnits[0], label: sharedUnits[0] });
      }
      promise = Promise.resolve(units);
    }
    promise.then(res => {
      const units = [];
      const unitLabels = {};
      const datasetUnitName = magnetReport.datasetUnitNamePlural ? magnetReport.datasetUnitNamePlural : "Work Settings";
      const workSettingReports = [
        { key: "magnet", value: "magnet", text: "ANCC MAGNET Report" },
        { key: "facility", value: "facility", text: `All Surveyed ${datasetUnitName}` },
      ];
      _.forEach(
        _.sortBy(res, function(unit) {
          return unit.value.toLowerCase();
        }),
        function(unit) {
          if (
            (!sharedMagnetReport || sharedUnitsSet.has("*") || sharedUnitsSet.has(unit.value)) &&
            unit.value !== "Other"
            // unit.value !== "Other" &&
            // units.length < 1
          ) {
            units.push(unit.value);
            unitLabels[unit.value] = unit.label;
            workSettingReports.push({ key: unit.value, value: unit.value, text: unit.label });
          }
        }
      );
      magnetReport.units = units;
      magnetReport.unitLabels = unitLabels;
      magnetReport.workSettingReports = workSettingReports;
      dispatch(actions.fetchMagnetReport(magnetReport));
    });
  });
};

export default {
  fetchMagnetReport,
};



// WEBPACK FOOTER //
// ./src/redux/magnetReport/operations.js